'use strict';

const playerInstances = new Map();

/**
 * Initialize Testimonial
 */
function initTestimonialCarousel() {
    const $carousel = $('.shop-the-look-carousel');
    const carouselLength = $carousel.length;
    if (carouselLength && carouselLength > 0) {
        $carousel.each(function () {
            const configEle = $(this);
            if (configEle === null || configEle === undefined) {
                return true;
            }

            const config = {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
                arrows: true,
                speed: 300,
                autoplay: configEle.data('carousel-autoplay'),
                autoplaySpeed: parseInt(configEle.data('carousel-autoplay-interval'), 10),
                prevArrow: configEle.siblings('.shop-the-look-btn-container').find('.shop-the-look-btn-prev'),
                nextArrow: configEle.siblings('.shop-the-look-btn-container').find('.shop-the-look-btn-next'),
                infinite: true,
                responsive: [
                    {
                        breakpoint: 599,
                        settings: 'unslick'
                    }
                ]
            };

            $(this).slick(config);
            return false;
        });
    }
}

// Shared helper functions
const helpers = {
    formatTime(seconds) {
        const h = Math.floor(seconds / 3600);
        const m = Math.floor((seconds % 3600) / 60);
        const s = Math.floor(seconds % 60);
        return h > 0 ? `${h}:${m < 10 ? '0' : ''}${m}:${s < 10 ? '0' : ''}${s}` : `${m}:${s < 10 ? '0' : ''}${s}`;
    },

    hideElement(el) {
        if (el) {
            el.style.cssText = 'opacity: 0; pointer-events: none; display: none;';
        }
    },

    showElement(el, display) {
        if (el) {
            el.style.cssText = `opacity: 1; pointer-events: auto; display: ${display || 'block'};`;
        }
    },

    getVideoId(mobile, tablet, desktop) {
        return window.innerWidth < 768 ? (mobile || desktop) : (desktop || mobile);
    },

    addClickAndKeyboard(el, handler) {
        if (!el) return;
        el.addEventListener('click', handler);
        el.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handler();
            }
        });
    }
};

/**
 * initializeVimeoVideo
 * @param {element} $container container
 */
function initializeVimeoVideo($container) {
    const $playerEl = $container.find('.video-hero-banner-player');
    if (!$playerEl.length || $container.attr('data-vimeo-initialized') === 'true') {
        return;
    }

    const videoId = helpers.getVideoId(
        $container.attr('data-vimeo-id-mobile'),
        $container.attr('data-vimeo-id-tablet'),
        $container.attr('data-vimeo-id-desktop')
    );

    if (!videoId) return;

    const autoplay = $container.attr('data-autoplay') === 'true';
    const loop = $container.attr('data-loop') === 'true';

    // Create fresh player element
    const $freshDiv = $('<div />').css({
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%'
    });

    $playerEl.empty().append($freshDiv);

    // Cache elements (jQuery objects)
    const els = {
        playBtn: $container.find('.video-hero-banner-play-btn'),
        pauseBtn: $container.find('.video-hero-banner-pause-btn'),
        clickOverlay: $container.find('.video-hero-banner-click-overlay'),
        poster: $container.find('.video-hero-banner-poster'),
        videoOverlay: $container.find('.video-hero-banner-overlay'),
        content: $container.find('.video-hero-banner-content'),
        controls: $container.find('.video-hero-banner-controls'),
        playIcon: $container.find('.play-icon'),
        pauseIcon: $container.find('.pause-icon'),
        volumeIcon: $container.find('.volume-icon'),
        muteIcon: $container.find('.mute-icon')
    };

    const playerKey = `player-${Date.now()}-${Math.floor(Math.random() * 10000)}`;
    let userInitiatedPlay = false;

    /**
     * getPlayer
     * @returns {element} element
    */
    function getPlayer() {
        return playerInstances.get(playerKey);
    }

    /**
     * togglePlayPause
    */
    function togglePlayPause() {
        const p = getPlayer();
        if (!p) return;

        p.getPaused().then((paused) => {
            if (paused) {
                userInitiatedPlay = true;
                p.play();
            } else {
                p.pause();
            }
        });
    }

    /**
     * handleVideoEnded
    */
    function handleVideoEnded() {
        const p = getPlayer();

        if (autoplay && p) {
            p.setCurrentTime(0).then(() => p.play()).catch($.noop);
            return;
        }

        els.playBtn.hide();
        els.pauseBtn.hide();
        els.playIcon.show();
        els.pauseIcon.hide();
        helpers.showElement(els.clickOverlay[0]);
        els.controls.show();

        if (p) {
            p.setCurrentTime(0).catch($.noop);
            p.pause().catch($.noop);
        }
    }

    // try {
    const player = new window.Vimeo.Player($freshDiv[0], {
        id: videoId,
        autoplay: true,
        loop,
        controls: false,
        muted: true,
        responsive: true,
        playsinline: true
    });

    playerInstances.set(playerKey, player);
    $container.attr('data-player-key', playerKey);

    player.ready().then(() => {
        $playerEl.find('iframe').parent().css('position', 'static');

        if (autoplay) {
            els.playBtn.hide().css('pointer-events', 'none');
            els.pauseBtn.hide();
            els.clickOverlay.hide().css('pointer-events', 'none');
            els.controls.hide();
        } else {
            player.pause().then(() => player.setCurrentTime(0)).catch($.noop);
        }

        player.getMuted().then((muted) => {
            els.volumeIcon.toggle(!muted);
            els.muteIcon.toggle(muted);
        });

        $container.find('.video-control-play-pause').on('click', () => {
            userInitiatedPlay = true;
            player.setMuted(false).then(() => player.play()).then(() => {
                els.playBtn.hide();
                els.pauseBtn.hide();
                els.controls.show();
                helpers.hideElement(els.videoOverlay[0]);
                helpers.hideElement(els.poster[0]);
                helpers.hideElement(els.content[0]);
            }).catch($.noop);
        });

        $container.find('.video-control-play-pause').on('click', togglePlayPause);

        $container.find('.video-control-mute').on('click', () => {
            player.getMuted().then((muted) => {
                player.setMuted(!muted);
            });
        });

        $container.find('.video-control-fullscreen').on('click', () => {
            player.getFullscreen().then((fs) => {
                if (fs) {
                    player.exitFullscreen();
                } else {
                    player.requestFullscreen();
                }
            });
        });

        els.clickOverlay.on('click', togglePlayPause);
    });

    player.on('play', () => {
        if (userInitiatedPlay) {
            $container.addClass('video-playing');
            els.playIcon.hide();
            els.pauseIcon.show();
            els.controls.show();
        }
    });

    player.on('pause', () => {
        els.playIcon.show();
        els.pauseIcon.hide();
    });

    player.on('ended', handleVideoEnded);
}

/**
 * Initialize Media (Image, Video, Vimeo)
 */
function initMedia() {
    $('.shop-the-look-video-component').each(function () {
        if ($(this).attr('data-has-vimeo') === 'true') {
            initializeVimeoVideo($(this));
        }
    });
}

/**
 * Initializes video autoplay, play/pause, and mute/unmute behavior
 */
function initVideoAutoplayControls() {
    var $wrappers = $('.shop-the-look-video-component');

    if (!$wrappers.length || !('IntersectionObserver' in window)) {
        return;
    }

    var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            var $wrapper = $(entry.target);
            var $video = $wrapper.find('video').get(0);
            var $playPauseIcon = $wrapper.find('.play-pause-icon');

            var playIcon = $wrapper.data('play-icon');
            var pauseIcon = $wrapper.data('pause-icon');

            if (!$video) return;

            if (entry.isIntersecting) {
                if ($video.hasAttribute('autoplay')) {
                    $video.play().catch(function () {});
                    $playPauseIcon.attr('src', pauseIcon);
                }
            } else {
                $video.pause();
                $playPauseIcon.attr('src', playIcon);
            }
        });
    }, { threshold: 0.5 });

    $wrappers.each(function () {
        var $wrapper = $(this);
        var video = $wrapper.find('video').get(0);
        if (!video) return;

        var $playPauseBtn = $wrapper.find('.play-btn');
        var $muteBtn = $wrapper.find('.mute-btn');
        var $playPauseIcon = $wrapper.find('.play-pause-icon');
        var $soundIcon = $wrapper.find('.soundIcon');

        var playIcon = $wrapper.data('play-icon');
        var pauseIcon = $wrapper.data('pause-icon');
        var muteIcon = $wrapper.data('mute-icon');
        var unmuteIcon = $wrapper.data('unmute-icon');

        // Play / Pause toggle
        $playPauseBtn.on('click', function () {
            if (video.paused) {
                video.play();
                $playPauseIcon.attr('src', pauseIcon);
            } else {
                video.pause();
                $playPauseIcon.attr('src', playIcon);
            }
        });

        // Mute / Unmute toggle
        $muteBtn.on('click', function () {
            video.muted = !video.muted;
            $soundIcon.attr('src', video.muted ? muteIcon : unmuteIcon);
        });

        // Observe wrapper for viewport visibility
        observer.observe($wrapper.get(0));
    });
}

/**
 * Updating the tile DOM to append quickview html as per the show the look component design
 */
function updateTileQuickView() {
    setTimeout(() => {
        $('.shop-the-look-carousel .product-tile').each(function () {
            var quickAddEl = $(this).find('.quick-add-product').html();
            if (quickAddEl) {
                $(this).find('.tile-body').append('<div class="tile-body-quick-add"><div class="row cart-and-ipay quick-add-product"> ' + quickAddEl + ' </div></div>');
            }
        });
    }, 1000);
}

/** Initialize keyboard accessibility for video play/pause
 */
function initKeyboardAccessibility() {
    $('.shop-the-look-component').on('keydown', function (e) {
        if (e.key === ' ' || e.keyCode === 32) {
            e.preventDefault();
            $('.shop-the-look-component .video-btn.play-btn').trigger('click');
        }
    });
}

$(document).ready(() => {
    initTestimonialCarousel();
    initMedia();
    initVideoAutoplayControls();
    updateTileQuickView();
    initKeyboardAccessibility();
});
